import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/resellers`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/resellers/${id}?include=owner`, options)
    .then((response) => {
      let reseller = jsona.deserialize(response.data);
      delete reseller.links;
      return reseller;
    });
}

function add(reseller) {
  const payload = jsona.serialize({
    stuff: reseller,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/resellers?include=owner`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(reseller) {
  const payload = jsona.serialize({
    stuff: reseller,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/resellers/${reseller.id}?include=owner`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/resellers/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
